"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.beta1Links = void 0;
const production_1 = require("./production");
const ORIGIN = 'https://beta1-m.place.naver.com';
const MYPLACE_WEB = 'https://beta1-m.place.naver.com/my';
const BOOKING_ORIGIN = 'https://stage-release-booking.io.naver.com';
/** https://oss.navercorp.com/Maps/sloop/wiki/Train-End-URLs-스펙/#host */
const TRAIN_TICKET_ORIGIN = 'https://stg-pt.map.naver.com/end-train';
exports.beta1Links = {
    ...production_1.productionLinks,
    FEDERATION_API_ON_BROWSER: 'https://stg-bff-gateway.place.naver.com',
    FEDERATION_API_ON_NODE: 'https://stg-place-federated-bff.io.naver.com',
    TRAIN_TICKET_CANCEL: `${TRAIN_TICKET_ORIGIN}/bridges/ticket/cancel/done?tNo=`,
    TRAIN_TICKET_DETAIL: `${TRAIN_TICKET_ORIGIN}/bridges/ticket/home?swNo=&sDt=&ssNo=&trPw=`,
    TRAIN_TICKET_MY_RESERVATION_LIST: `${TRAIN_TICKET_ORIGIN}/bridges/schedule-board/web/home?ac=ticket&userQuery=where%3Amo_fusion%2Cmenu%3Amap_tts-resercation%22`,
    TRAIN_TICKET_RESERVATION: 'https://map.naver.com/p/train',
    BOOKING_GRAPHQL: `${BOOKING_ORIGIN}/graphql`,
    MYPLACE_WEB,
    MYPLACE_API: 'https://beta1-api.place.naver.com/my',
    MYPLACE_REVIEW_FEED: `${MYPLACE_WEB}/:userId/reviewfeed?reviewId=:reviewId`,
    API_URL_ON_BROWSER: 'https://beta1-api.place.naver.com/my',
    API_URL_ON_NODE: 'http://profile-api-beta1.myplace.svc.ar2.io.navercorp.com/my',
    FILE_UPLOAD: 'https://beta-files.place.naver.com/my/upload',
    TRAVEL_HOTEL_REVIEW: `https://stage-hotels.naver.com/hotels/:hotelId/cpReview/myplace`,
    TRAVEL_HOTEL_DETAIL: `https://stage-hotels.naver.com/hotels/:hotelId`,
    TRAVEL_HOTEL_MY: `https://stage-travel.naver.com/my/reviews/me/hotel`,
    TRAVEL_HOTEL_MY_BOOKING: `https://stage-travel.naver.com/my/bookings/hotels`,
    ORIGIN,
};
